function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "A0",
  transform: "translate(-1032.000000, -464.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "undraw_develop_app_kvt2",
  transform: "translate(1032.000000, 464.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M134.808,64.247 L133.322,64.247 L133.322,23.552 C133.322,10.5440373 122.776963,-0.001 109.769,-0.001 L23.553,-0.001 C10.5450373,-0.001 5.68434189e-14,10.5440373 5.68434189e-14,23.552 L5.68434189e-14,246.805 C5.68434189e-14,259.812963 10.5450373,270.358 23.553,270.358 L109.77,270.358 C122.777963,270.358 133.323,259.812963 133.323,246.805 L133.323,93.214 L134.808,93.214 L134.808,64.247 Z",
  id: "Path",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.521,21.975 L128.521,248.383 C128.517241,258.243777 120.524777,266.237136 110.664,266.241 L22.675,266.241 C12.8082711,266.241 4.80865673,258.244729 4.807,248.378 L4.807,21.975 C4.80976103,12.1090523 12.809052,4.114 22.675,4.114 L33.348,4.114 C32.2835739,6.73120702 32.5901911,9.70637116 34.1660275,12.0514756 C35.7418639,14.3965801 38.3806214,15.8046193 41.206,15.808 L91.369,15.808 C94.1943786,15.8046193 96.8331361,14.3965801 98.4089725,12.0514756 C99.9848089,9.70637116 100.291426,6.73120702 99.227,4.114 L110.66,4.114 C120.522339,4.114 128.517687,12.1086617 128.521,21.971 L128.521,21.975 Z",
  id: "Path",
  fill: "#E6E6E6"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  x: 22.282,
  y: 139.879,
  width: 88.764,
  height: 88.764
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  x: 41.881,
  y: 99.857,
  width: 50.068,
  height: 3.763
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  x: 35.182,
  y: 109.635,
  width: 63.011,
  height: 3.763
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#E6E6E6",
  x: 47.86,
  y: 148.448,
  width: 34.552,
  height: 2.597
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#9D6B53",
  x: 47.86,
  y: 156.072,
  width: 53.356,
  height: 2.597
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#E6E6E6",
  x: 48.415,
  y: 163.333,
  width: 43.484,
  height: 2.597
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#E6E6E6",
  x: 47.86,
  y: 171.3,
  width: 25.385,
  height: 2.597
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#9D6B53",
  x: 47.86,
  y: 179.082,
  width: 38.313,
  height: 2.597
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#E6E6E6",
  x: 32.112,
  y: 147.631,
  width: 4.231,
  height: 4.231
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#9D6B53",
  x: 32.112,
  y: 155.255,
  width: 4.231,
  height: 4.231
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#E6E6E6",
  x: 32.112,
  y: 162.516,
  width: 4.231,
  height: 4.231
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#E6E6E6",
  x: 32.112,
  y: 170.483,
  width: 4.231,
  height: 4.231
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#9D6B53",
  x: 32.112,
  y: 178.265,
  width: 4.231,
  height: 4.231
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#E6E6E6",
  x: 47.86,
  y: 186.912,
  width: 34.552,
  height: 2.597
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#9D6B53",
  x: 47.86,
  y: 194.536,
  width: 53.356,
  height: 2.597
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#E6E6E6",
  x: 48.415,
  y: 201.797,
  width: 43.484,
  height: 2.597
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#E6E6E6",
  x: 47.86,
  y: 209.764,
  width: 25.385,
  height: 2.597
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#E6E6E6",
  x: 47.86,
  y: 217.546,
  width: 38.313,
  height: 2.597
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#E6E6E6",
  x: 32.112,
  y: 186.096,
  width: 4.231,
  height: 4.231
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#9D6B53",
  x: 32.112,
  y: 193.72,
  width: 4.231,
  height: 4.231
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#E6E6E6",
  x: 32.112,
  y: 200.98,
  width: 4.231,
  height: 4.231
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#E6E6E6",
  x: 32.112,
  y: 208.947,
  width: 4.231,
  height: 4.231
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#E6E6E6",
  x: 32.112,
  y: 216.729,
  width: 4.231,
  height: 4.231
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  cx: 66.664,
  cy: 59.6,
  r: 28.94
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.427,45.407 C60.6569416,45.407 55.4550403,48.8827993 53.2469346,54.2136382 C51.0388288,59.544477 52.2593672,65.6805379 56.3394147,69.7605853 C60.4194621,73.8406328 66.555523,75.0611712 71.8863618,72.8530654 C77.2172007,70.6449597 80.693,65.4430584 80.693,59.673 C80.693,51.7941058 74.3058942,45.407 66.427,45.407 Z M66.427,49.687 C68.7907787,49.687 70.707,51.6032213 70.707,53.967 C70.707,56.3307787 68.7907787,58.247 66.427,58.247 C64.0632213,58.247 62.147,56.3307787 62.147,53.967 C62.147,52.8318734 62.5979273,51.7432387 63.400583,50.940583 C64.2032387,50.1379273 65.2918734,49.687 66.427,49.687 L66.427,49.687 Z M66.427,70.287 C62.9943821,70.2713878 59.7908754,68.5618529 57.867,65.719 C57.936,62.866 63.573,61.295 66.427,61.295 C69.281,61.295 74.918,62.866 74.987,65.719 C73.0619876,68.5611087 69.8596194,70.2715325 66.427,70.291 L66.427,70.287 Z",
  id: "Shape",
  fill: "#9D6B53"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#E6E6E6",
  cx: 179.345,
  cy: 273.398,
  rx: 32.205,
  ry: 6.601
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.212,175.494 L140.982,174.76 C140.982,174.76 132.338,170.771 131.814,173.792 C131.29,176.813 139.54,179.492 139.54,179.492 L148.419,178.542 L145.212,175.494 Z",
  id: "Path",
  fill: "#FFB8B8"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#575A89",
  points: "169.813 144.908 163.886 171.886 144.106 174.679 143.348 182.639 168.855 182.707 181.612 159.4"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#000000",
  opacity: 0.2,
  points: "169.813 144.908 163.886 171.886 144.106 174.679 143.348 182.639 168.855 182.707 181.612 159.4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.704,152.73 L136.686,149.677 C136.686,149.677 131.962,141.411 129.786,143.567 C127.61,145.723 132.77,152.69 132.77,152.69 L140.551,157.07 L139.704,152.73 Z",
  id: "Path",
  fill: "#FFB8B8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.287,136.373 L185.003,135.467 C187.874494,135.470775 190.5958,134.184424 192.415512,131.963131 C194.235224,129.741838 194.960839,126.82059 194.392,124.006 L194.392,124.006 C194.397308,120.689235 193.084201,117.506339 190.7418,115.158123 C188.399399,112.809908 185.219768,111.488915 181.903,111.485984 L181.903,111.485984 C178.586235,111.480692 175.403339,112.793799 173.055123,115.1362 C170.706908,117.478601 169.385915,120.658232 169.383,123.975 L169.383,123.975 C168.404853,127.378446 169.311844,131.04526 171.763821,133.600261 C174.215797,136.155262 177.842198,137.212319 181.283,136.375 L181.287,136.373 Z",
  id: "Path",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#2F2E41",
  points: "159.431 198.305 162.456 231.425 167.934 263.935 177.134 263.947 175.948 232.051 171.089 193.405"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169.166,262.092 L163.029,265.764 C163.029,265.764 153.215,266.978 155.051,270.047 C156.887,273.116 178.351,271.303 178.351,270.076 C178.351,268.849 177.751,262.103 176.521,262.101 L169.166,262.092 Z",
  id: "Path",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M186.585,195.439 C186.585,195.439 186.412,200.174 182.11,207.528 L182.695,230.219 L204.737,258.457 L196.756,265.193 L169.811,234.493 L163.111,197.693 L171.711,189.118 L186.585,195.439 Z",
  id: "Path",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M202.898,258.455 C202.898,258.455 210.256,259.691 209.025,262.755 C207.794,265.819 204.711,279.921 196.741,278.071 C196.741,278.071 193.061,278.071 194.291,275.615 C195.029923,274.140406 195.850532,272.708181 196.749,271.325 L196.759,263.353 L202.898,258.455 Z",
  id: "Path",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#FFB8B8",
  cx: 177.304,
  cy: 127.798,
  r: 9.199
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FFB8B8",
  points: "181.589 133.936 181.576 144.362 171.764 144.35 173.003 133.926"
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.638,199.561 L181.551,198.542 C173.785342,197.236798 165.83246,197.571645 158.204,199.525 L160.957,172.115 L161.315,168.542 L162.083,160.891 C162.083,160.891 159.429,150.809 163.324,147.403 C168.079,143.245 172.288,139.935 172.288,139.935 L181.582,140.679 C186.782,151.04 185.652,164.062 182.147,178.091 L187.638,199.561 Z",
  id: "Path",
  fill: "#575A89"
}), /*#__PURE__*/React.createElement("path", {
  d: "M177.492,142.102 L157.006,160.634 L139.278,151.428 L135.556,155.983 L151.215,169.783 C153.408077,171.356063 156.286167,171.602811 158.715,170.426 L178.692,160.758 L177.492,142.102 Z",
  id: "Path",
  fill: "#575A89"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#2F2E41",
  cx: 195.062,
  cy: 115.086,
  r: 5.935
}), /*#__PURE__*/React.createElement("path", {
  d: "M189.585,111.895 C189.58646,110.117839 190.384626,108.434952 191.759892,107.309365 C193.135158,106.183777 194.942628,105.734079 196.685,106.084 C194.612415,105.105142 192.161351,105.407926 190.389276,106.861721 C188.6172,108.315516 187.841249,110.660146 188.396193,112.884064 C188.951136,115.107981 190.73766,116.813187 192.985,117.264 C190.907418,116.283938 189.582757,114.192143 189.585,111.895 L189.585,111.895 Z",
  id: "Path",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.494,115.261 L176.494,113.788 L170.341,117.645 C167.25172,119.580995 165.572381,123.138461 166.041,126.754 L172.204,125.192 L173.584,121.732 L173.584,121.732 C174.471311,123.180168 175.709485,124.381197 177.184,125.224 C180.676,127.224 181.484,131.489 181.898,136.083 L188.649,132.412 L192.949,125.672 L184.494,115.261 Z",
  id: "Path",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#000000",
  opacity: 0.2,
  points: "176.94 155.186 160.962 172.116 161.32 168.543"
}))));

function SvgMakeprofile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "212px",
    height: "280px",
    viewBox: "0 0 212 280",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "undraw_develop_app_kvt2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeprofile);
export default __webpack_public_path__ + "static/media/makeprofile.b9cf993f.svg";
export { ForwardRef as ReactComponent };